import React from "react";
import { Row, Col, Skeleton, Card } from "antd";

const SelectionSkeleton = () => {
  const skeletonCards = Array.from({ length: 4 }); // Adjust for the total number of cards (e.g., 8 = 2 rows of 4 columns)

  return (
    <div style={{ padding: "50px 100px" }}>
      <Row gutter={[16, 16]} justify="start">
        {skeletonCards.map((_, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6}>
            <Card
              style={{
                borderRadius: "8px",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                height: 200,
              }}
            >
              <div className="flex gap-2">
                <Skeleton.Avatar
                  active
                  size="large"
                  shape="circle"
                  style={{ marginBottom: "10px" }}
                />
                <div className="w-full">
                  <Skeleton active paragraph={{ rows: 2 }} title={false} />
                  {/* <Skeleton active paragraph={{ rows: 1 }} title={false} /> */}
                </div>
              </div>
              <br />
              <br />
              <Skeleton active paragraph={{ rows: 1 }} title={false} />
              <Skeleton active paragraph={{ rows: 1 }} title={false} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SelectionSkeleton;
